// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import AmountUnitController from "./amount_unit_controller";
application.register("amount-unit", AmountUnitController);

import AudienceModeController from "./audience_mode_controller";
application.register("audience-mode", AudienceModeController);

import AutoSubmitController from "./auto_submit_controller";
application.register("auto-submit", AutoSubmitController);

import BreakHintController from "./break_hint_controller";
application.register("break-hint", BreakHintController);

import CalculatorExampleController from "./calculator_example_controller";
application.register("calculator-example", CalculatorExampleController);

import CalculatorInstallController from "./calculator_install_controller";
application.register("calculator-install", CalculatorInstallController);

import CalculatorPanelController from "./calculator_panel_controller";
application.register("calculator-panel", CalculatorPanelController);

import CalculatorWaterComparisonController from "./calculator_water_comparison_controller";
application.register("calculator-water-comparison", CalculatorWaterComparisonController);

import ClipboardController from "./clipboard_controller";
application.register("clipboard", ClipboardController);

import DeferredImageController from "./deferred_image_controller";
application.register("deferred-image", DeferredImageController);

import DoseEntryController from "./dose_entry_controller";
application.register("dose-entry", DoseEntryController);

import DoseGuideController from "./dose_guide_controller";
application.register("dose-guide", DoseGuideController);

import DrawRulerController from "./draw_ruler_controller";
application.register("draw-ruler", DrawRulerController);

import DrawerController from "./drawer_controller";
application.register("drawer", DrawerController);

import DropdownController from "./dropdown_controller";
application.register("dropdown", DropdownController);

import ExclusiveCheckboxesController from "./exclusive_checkboxes_controller";
application.register("exclusive-checkboxes", ExclusiveCheckboxesController);

import FrameFallbackController from "./frame_fallback_controller";
application.register("frame-fallback", FrameFallbackController);

import HalfLifeCalculatorController from "./half_life_calculator_controller";
application.register("half-life-calculator", HalfLifeCalculatorController);

import HelloController from "./hello_controller";
application.register("hello", HelloController);

import HelpPlatformController from "./help_platform_controller";
application.register("help-platform", HelpPlatformController);

import HelpShotController from "./help_shot_controller";
application.register("help-shot", HelpShotController);

import HelpThemeController from "./help_theme_controller";
application.register("help-theme", HelpThemeController);

import IndexFiltersController from "./index_filters_controller";
application.register("index-filters", IndexFiltersController);

import MarkdownEditorController from "./markdown_editor_controller";
application.register("markdown-editor", MarkdownEditorController);

import MeasureController from "./measure_controller";
application.register("measure", MeasureController);

import MembershipController from "./membership_controller";
application.register("membership", MembershipController);

import MixSourcesController from "./mix_sources_controller";
application.register("mix-sources", MixSourcesController);

import MobileNavController from "./mobile_nav_controller";
application.register("mobile-nav", MobileNavController);

import NestedFormController from "./nested_form_controller";
application.register("nested-form", NestedFormController);

import PasswordVisibilityController from "./password_visibility_controller";
application.register("password-visibility", PasswordVisibilityController);

import PhoneFieldController from "./phone_field_controller";
application.register("phone-field", PhoneFieldController);

import ProtocolEditorController from "./protocol_editor_controller";
application.register("protocol-editor", ProtocolEditorController);

import ProtocolFormController from "./protocol_form_controller";
application.register("protocol-form", ProtocolFormController);

import PubmedLinksController from "./pubmed_links_controller";
application.register("pubmed-links", PubmedLinksController);

import SkippedStepsController from "./skipped_steps_controller";
application.register("skipped-steps", SkippedStepsController);

import SkyController from "./sky_controller";
application.register("sky", SkyController);

import SupplyEditorController from "./supply_editor_controller";
application.register("supply-editor", SupplyEditorController);

import SymptomFormController from "./symptom_form_controller";
application.register("symptom-form", SymptomFormController);

import TapActionController from "./tap_action_controller";
application.register("tap-action", TapActionController);

import ThemeController from "./theme_controller";
application.register("theme", ThemeController);

import ToastController from "./toast_controller";
application.register("toast", ToastController);

import VialEditorController from "./vial_editor_controller";
application.register("vial-editor", VialEditorController);

import VialMixController from "./vial_mix_controller";
application.register("vial-mix", VialMixController);
